<template>
  <div class="voucher">
    <div class="voucher_container">
      <ReceiptDetails
        :id="id"
        :isGuest="true"
        :taxpayer="{}"
        :showHeader="true"
      />
    </div>
  </div>
</template>

<script lang="ts">
import Component from 'vue-class-component';
import Vue from 'vue';

import ReceiptDetails from '@/components/modals/ReceiptDetails.vue';

@Component({
  name: 'Voucher',
  components: { ReceiptDetails },
})
export default class Voucher extends Vue {
  get id() {
    return this.$route.params.id;
  }
}
</script>

<style lang="scss" scoped>
.voucher {
  padding: 4rem 0;
  height: 100%;
  min-height: 100vh;
  width: 100%;
  max-width: 808px;
  margin: 0 auto;

  &_container {
    padding: 2rem 4rem;
    height: 100%;
    min-height: 100vh;
    border: 1px solid #dfe0eb !important;
    box-shadow: 0 0 2px #00000026;
    background-color: white;
  }
}
</style>
